import {
  trialExtensionReasons,
  UpgradeReason,
} from '@zapier/upsells/src/types';

type Props = {
  currentPlanAmount: number;
  enabledTrialExtensions: (string | null)[] | null;
  isTrialingCompanies: boolean;
  isTrialingProfessional: boolean;
  isTrialingTeams: boolean;
  reason: UpgradeReason;
};

export const canExtendTrial = ({
  currentPlanAmount,
  enabledTrialExtensions,
  reason,
  isTrialingCompanies,
  isTrialingProfessional,
  isTrialingTeams,
}: Props) => {
  const reasonIsEligibleForTrialExtension = Object.values(
    trialExtensionReasons
  ).includes(reason);

  const accountIsEligibleForTrialExtension =
    !isTrialingProfessional &&
    !isTrialingTeams &&
    !isTrialingCompanies &&
    currentPlanAmount === 0 &&
    !(enabledTrialExtensions ?? []).includes(reason);

  return (
    reasonIsEligibleForTrialExtension && accountIsEligibleForTrialExtension
  );
};
